import utils from '@/core/utils'
import productUtils from '@/core/productUtils'

const methods = {
  getCategoryCode() {
    return 'Basic'
  },
  getCurveFormItems(allProperties) {
    const allProps = productUtils.getAllPropertiesByCode(allProperties, 'isPerformanceFilter', (value) => !!value)
    const ret = []
    allProps.forEach((item) => {
      ret.push({
        label: item.name,
        code: item.code,
        dataType: item.dataType,
        suffix: item.unitSymbol,
        // 校验必填
        required: false
      })
    })
    return ret
  },
  getSearchProperties({ aggProperties }) {
    const ret = []
    aggProperties.forEach((item) => {
      const aggProperty = aggProperties.find((x) => x.code === item.code)
      if (!aggProperty) { return }
      const obj = {
        label: item.name,
        code: item.code,
        dataType: item.dataType,
        suffix: item.unitSymbol || null
      }
      if (item.dataType === 'Bool') {
        obj.values = [{ code: 1, name: '是' }, { code: 0, name: '否' }]
      } else if (item.dataType === 'Enum') {
        obj.values = item.values || []
      }
      ret.push(obj)
    })
    return ret
  },
  getColumns({ allProperties, curveProperties }) {
    const ret = [
      {
        label: '产品型号',
        prop: 'model',
        minWidth: '180px',
        templateName: 'model',
        fixed: true
      },
    ]
    const allProps = productUtils.getAllPropertiesByCode(allProperties, 'isListDisplay', (value) => !(value === null || value === undefined || value === ''))
    allProps.forEach((item) => {
      const col = {
        label: item.unitSymbol ? `${item.name}(${item.unitSymbol})` : item.name,
        prop: item.code,
      }
      let width = utils.calcTextWidth(col.label)
      const listDisplayConfigItem = item.configItemValues.find((x) => x.code === 'isCustomSort' && x.value === 'true')
      if (listDisplayConfigItem) {
        col.sortable = 'custom'
        width += 14
      }
      width += 10
      col.minWidth = `${width}px`
      ret.push(col)
      if (curveProperties && curveProperties.find((c) => c.code === item.code)) {
        const value = curveProperties.find((c) => c.code === item.code).value
        if (value) {
          const label = `${item.name}偏差率(%)`
          ret.push({
            label,
            templateName: 'deviation',
            templateData: { relateProp: item.code },
            minWidth: `${utils.calcTextWidth(label)}px`
          })
        }
      }
    })
    return ret
  },
  getDesignProperties({ allProperties, curveProperties, emptyValue }) {
    const ret = []
    // 品类属性
    if (!allProperties) {
      return ret
    }
    // 过滤性能筛选属性
    const designProperties = productUtils.getAllPropertiesByCode(allProperties, 'isPerformanceFilter', (value) => !!value)
    designProperties.forEach((d, i) => {
      let values = null
      // 从搜索条件获取设计值
      if (curveProperties) {
        const property = curveProperties.find((c) => c.code === d.code)
        values = property ? property.value : null
      }
      values = values || emptyValue || null
      ret.push({
        codes: d.code,
        name: `设计${d.name}`,
        sort: i,
        unit: d.unitSymbol,
        values: values,
        type: 'design'
      })
    })
    return ret
  },

  // 用于展示的列表数据
  getTableData({ products, allProperties, samplesMapping }) {
    const data = []
    products.forEach((item) => {
      const productProps = item.productPropertyValues || []
      const sampleMap = samplesMapping.find((s) => s.productId === item.id) || {}
      const obj = {
        id: item.id,
        sampleId: sampleMap.sampleId,
        brandCode: item.brandCode,
        brandName: item.brandName,
        gjwCategoryCode: item.gjwCategoryCode,
        gjwCategoryName: item.gjwCategoryName,
        speedControl: item.speedControl,
        name: item.name,
        productSeriesId: item.productSeriesId,
        model: item.model,
        productSeriesName: item.productSeriesName,
        imageUrl: item.imageUrl,
      }
      productProps.forEach((p) => {
        if (p.type === 'Range') {
          obj[p.code] = `${p.valueFrom} ~ ${p.valueTo}`
        } else if (p.type === 'Enum' && p.values && allProperties) {
          const propertieyD = allProperties.find((a) => a.code === p.code)
          if (propertieyD && propertieyD.enumValues) {
            const values = []
            p.values.forEach((v) => {
              const enumValue = propertieyD.enumValues.find((ev) => v === ev.code)
              if (enumValue) {
                values.push(enumValue.name)
              }
            })
            obj[p.code] = values.join('，')
          }
        } else if (p.type === 'Bool') {
          if (p.value === 'true') obj[p.code] = '是'
          else if (p.value === 'false') obj[p.code] = '否'
        } else {
          obj[p.code] = p.value
        }
        obj[`${p.code}DeviationRate`] = p.deviationRate
      })

      data.push(obj)
    })
    return data
  }
}
export default {
  namespaced: true,
  ...methods
}
